import { render, staticRenderFns } from "./ActivityLog.vue?vue&type=template&id=507912b8&scoped=true"
import script from "./ActivityLog.vue?vue&type=script&lang=js"
export * from "./ActivityLog.vue?vue&type=script&lang=js"
import style0 from "./ActivityLog.vue?vue&type=style&index=0&id=507912b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507912b8",
  null
  
)

export default component.exports